/**
 * src/components/ui/OopsSpider.tsx — the Attic "oops" mascot (web).
 *
 * Nano Banana folk-style bold jumper (generated 2026-07-09, brand style
 * anchor: splash-concept-1) — tiny, plush, arachnophobe-safe, tangled in its
 * own silk with a sheepish sweat drop, matching the error copy ("something
 * got tangled on our end"). Same artwork as attic-mobile's oops-spider.tsx.
 * Circle-masked so the illustration's paper-cream ground reads as a badge on
 * any page background.
 */

import spider from '../../assets/oops-spider.webp';

export function OopsSpider({ size = 160 }: { size?: number }) {
  return (
    <img
      src={spider}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      style={{ display: 'block', borderRadius: '50%' }}
    />
  );
}
